import { Button, Modal } from '@design-system';
import { IConfirmationModal } from './ConfirmationModal.types';
import styles from './ConfirmationModal.module.scss';
import classNames from 'classnames';
import { formatKeyValue } from '../TwoFactorAuthentication.service';

export const ConfirmationModal: React.FC<IConfirmationModal> = (props) => {
  const {
    title,
    confirmMessage,
    confirmText = 'YES',
    className = '',
    onCancel,
    onConfirm,
    showKey = false,
    keyValue = '',
    infoText = 'Copy to clipboard',
    onInfo,
    visible,
  } = props;

  return (
    <Modal
      title={title}
      className={classNames(className, styles['confirmation-modal-content'])}
      visible={visible}
      onModalClosed={onCancel}
    >
      <div>
        <p className={styles['confirm-message']}>{showKey ? formatKeyValue(keyValue) : confirmMessage}</p>
        <div className={`mt-5 ${styles['actions-container']}`}>
          {showKey ? (
            <Button
              variant="outlined"
              size="medium"
              styleType="secondary"
              onClick={onInfo}
              className="md:!text-[14px] w-full md:w-[unset] !h-[40px] md:!h-[32px] !capitalize"
            >
              {infoText}
            </Button>
          ) : (
            <Button
              variant="contained"
              styleType="primary"
              onClick={onConfirm}
              className="md:!text-[14px] w-full md:w-[unset] !h-[40px] md:!h-[32px] !px-10"
            >
              {confirmText}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};
